import './PlanetCarousel.css';

export default function PlanetCarousel({ currentSection, showRings, showMissions, showSatellites, sections }) {
  const allSections = [
    { key: 'description', content: sections.description, visible: true },
    { key: 'rings', content: sections.rings, visible: showRings },
    { key: 'missions', content: sections.missions, visible: showMissions },
    { key: 'satellites', content: sections.satellites, visible: showSatellites },
  ];

  const visibleSections = allSections.filter(s => s.visible);

  const currentKey = allSections[currentSection]?.key;
  const currentIndex = visibleSections.findIndex(s => s.key === currentKey);

  return (
    <div className="carousel-viewport">
      <div
        className="carousel-container"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {visibleSections.map(({ key, content }) => (
          <div key={key} className="carousel-page">
            {content}
          </div>
        ))}
      </div>
    </div>
  );
}
